export default __webpack_public_path__ + "static/media/hht1_direction_timeline_03.13041fad.jpg";